class BrandSlider extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    this.dataset.initialized = 'true';
    this.#setupArrows();
  }

  #setupArrows() {
    const scroller = this.querySelector('[data-brand-slider-scroller]');
    const previousButton = this.querySelector('.slideshow-control--previous');
    const nextButton = this.querySelector('.slideshow-control--next');

    if (!scroller || !previousButton || !nextButton) return;

    const scrollAmount = () => {
      const slide = scroller.querySelector('.brand-slider-block__slide');
      if (!slide) return 300;

      return slide.offsetWidth + parseFloat(getComputedStyle(scroller).gap || 16);
    };

    previousButton.addEventListener('click', () => {
      scroller.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });

    nextButton.addEventListener('click', () => {
      scroller.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });

    const updateArrows = () => {
      const { scrollLeft, scrollWidth, clientWidth } = scroller;

      previousButton.disabled = scrollLeft <= 1;
      nextButton.disabled = scrollLeft + clientWidth >= scrollWidth - 1;
    };

    const snapToNearestSlide = () => {
      const amount = scrollAmount();
      const target = Math.round(scroller.scrollLeft / amount) * amount;

      scroller.scrollTo({ left: target, behavior: 'smooth' });
    };

    let isPointerDown = false;
    let isDragging = false;
    let suppressClick = false;
    let pointerId = null;
    let startX = 0;
    let startY = 0;
    let startScrollLeft = 0;

    const endDrag = () => {
      if (!isPointerDown && !isDragging) return;

      if (pointerId !== null && scroller.hasPointerCapture?.(pointerId)) {
        scroller.releasePointerCapture(pointerId);
      }

      if (isDragging) {
        suppressClick = true;
        snapToNearestSlide();

        window.setTimeout(() => {
          suppressClick = false;
        }, 0);
      }

      isPointerDown = false;
      isDragging = false;
      pointerId = null;
      scroller.classList.remove('is-pointer-down', 'is-dragging');
    };

    scroller.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' || event.button !== 0) return;

      isPointerDown = true;
      isDragging = false;
      pointerId = event.pointerId;
      startX = event.clientX;
      startY = event.clientY;
      startScrollLeft = scroller.scrollLeft;

      scroller.classList.add('is-pointer-down');
      scroller.setPointerCapture?.(event.pointerId);
    });

    scroller.addEventListener('pointermove', (event) => {
      if (!isPointerDown) return;

      const deltaX = event.clientX - startX;
      const deltaY = event.clientY - startY;

      if (!isDragging) {
        if (Math.abs(deltaX) < 8 || Math.abs(deltaX) <= Math.abs(deltaY)) return;

        isDragging = true;
        scroller.classList.add('is-dragging');
      }

      event.preventDefault();
      scroller.scrollLeft = startScrollLeft - deltaX;
      updateArrows();
    });

    scroller.addEventListener('pointerup', endDrag);
    scroller.addEventListener('pointercancel', endDrag);
    scroller.addEventListener('lostpointercapture', endDrag);

    scroller.addEventListener(
      'click',
      (event) => {
        if (!suppressClick) return;

        event.preventDefault();
        event.stopPropagation();
      },
      true
    );

    scroller.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();

    new ResizeObserver(updateArrows).observe(scroller);
  }
}

if (!customElements.get('brand-slider')) {
  customElements.define('brand-slider', BrandSlider);
}
